import AbstractModel from "~/stories_widget/models/AbstractModel";
import {IData} from "./AbstractModel";
import {AxiosRequestConfig, Method} from "axios";
import api from "~/stories_widget/api2";
import {debug} from "~/stories_widget/util/debug";

export type SendApiRequestConfig = {
    id: string;
    url: string;
    method: Method;
    params: Nullable<Dict<any>>;
    headers: Nullable<Dict<any>>;
    data: Nullable<Dict<any>>;
    cb: string;
};

export class NarrativeData extends AbstractModel {

    public static sentData(narrativeId: number, data: IData) {
        return this.update('story-data/' + narrativeId, data, 'put');
    }

    public static sendApiRequest({url, method, params, headers, data}: Omit<SendApiRequestConfig, "cb" | "id">) {
        let config: AxiosRequestConfig = {
            url,
            method
        };
        if (['post', 'put', 'path'].indexOf(method) !== -1) {
            config.data = data ?? {};
        } else {
            config.params = params ?? {};
        }
        return new Promise(resolve => {
            api.request(config)
                .then(function (response) {
                    let obj: any;
                    obj = response.data;

                    resolve({
                        data: obj, status: 200, headers: [{}]
                    });


                })
                .catch(e => {
                    resolve({
                        data: e, status: 400, headers: [{}]
                    });

                })
        });
    }


    public static sendApiRequestPromise(configPlain: string, resolve: Function) {

        const {id, url, method, params, headers, data, cb}: SendApiRequestConfig = JSON.parse(configPlain) as SendApiRequestConfig;

        let config: AxiosRequestConfig = {
            url,
            method
        };
        if (['post', 'put', 'path'].indexOf(method) !== -1) {
            config.data = data;
        } else {
            config.params = params;
        }
        api.request(config)
            .then(function (response) {
                let obj: any;
                obj = response.data;

                let respString = JSON.stringify({
                    requestId: id, data: JSON.stringify(obj), status: 200, headers: [{}]
                });
                resolve(cb, respString);
            })
            .catch(e => {
                console.error(e);
                let respString = JSON.stringify({
                    requestId: id, data: JSON.stringify(e), status: 400, headers: [{}]
                });
                resolve(cb, respString);
            });

    }

}




